<template>
	<div id="modal-inventory-products-edit-product">
		<b-modal :id="modalName" title="Edit Product: " scrollable hide-footer size="lg">
            <template v-slot:modal-title>
                <b-container fluid v-if="!showAttributes && !showImages && !showComponents">
                    <b-row>
                        <b-col cols="9">
                            <span>
                                Edit Product: {{ edit.sku }}
                            </span>
                        </b-col>
                        <b-col cols="3">
                            <b-form-select v-model="edit.product_type">
                                <b-form-select-option value="Simple">Simple</b-form-select-option>
                                <b-form-select-option value="Bundle">Bundle</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-container>

                <span v-else-if="showImages">
                    <b-button @click="showImages = 0">Go Back</b-button> Images: {{ edit.sku }}
                </span>
                <span v-else-if="showAttributes">
                    <b-button @click="showAttributes = 0">Go Back</b-button> Attributes: {{ edit.sku }}
                </span>
				<span v-else-if="showComponents">
                    <b-button @click="showComponents = 0">Go Back</b-button> Components: {{ edit.sku }}
                </span>
            </template>

            <div v-if="dataReady">
                <div v-show="!showAttributes && !showImages && !showComponents" :key="attributesOption.key">
                    <validation-observer ref="observer" v-slot="{ handleSubmit }">
                        <b-form @submit.stop.prevent="handleSubmit(editProduct)">
                            <b-form-row>
                                <b-col>
                                    <b-form-row>
                                        <b-col>
                                            <validation-provider
                                              name="SKU"
                                              :rules="{ required: true }"
                                              v-slot="validationContext"
                                            >
                                                <b-form-group
                                                    id="input-group-sku"
                                                    label="SKU:"
                                                    label-for="input-sku"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-sku"
                                                        v-model="edit.sku"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                        :state="getValidationState(validationContext)"
                                                        aria-describedby="input-sku-live-feedback"
                                                    >
                                                    </b-form-input>

                                                    <b-form-invalid-feedback id="input-sku-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col>
                                            <b-form-group
                                                id="input-group-categories"
                                                label="Category:"
                                                label-for="input-categories"
                                                label-size="sm"
                                            >
                                                <treeselect
                                                    name="treeSelect"
                                                    class="treeSelect"
                                                    clearable
                                                    searchable
                                                    open-on-click
                                                    clear-on-select
                                                    close-on-select
                                                    disableBranchNodes
                                                    placeholder=""
                                                    :options="categories"
                                                    v-model="edit.categories_id"
                                                    />
                                            </b-form-group>
                                        </b-col>

                                        <b-col>
                                            <b-form-group
                                                id="input-group-vendor"
                                                label="Vendor:"
                                                label-for="input-vendor"
                                                label-size="sm"
                                            >
                                                <treeselect
                                                    name="treeSelect"
                                                    class="treeSelect"
                                                    clearable
                                                    searchable
                                                    open-on-click
                                                    clear-on-select
                                                    close-on-select
                                                    disableBranchNodes
                                                    placeholder=""
                                                    :options="vendors"
                                                    v-model="edit.vendor_id"
                                                    />
                                            </b-form-group>
                                        </b-col>

                                        <b-col>
                                            <b-form-group
                                                id="input-group-mpn"
                                                label="MPN:"
                                                label-for="input-mpn"
                                                label-size="sm"
                                            >
                                                <b-form-input
                                                    id="input-mpn"
                                                    v-model="edit.mpn"
                                                    type="text"
                                                    placeholder=""
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-form-row>

                                    <b-form-row>
                                        <b-col>
                                            <validation-provider
                                                name="Sales Price"
                                                rules="decimal"
                                                v-slot="validationContext"
                                            >
                                                <b-form-group
                                                    id="input-group-price"
                                                    label="Sales Price:"
                                                    label-for="input-price"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-price"
                                                        v-model="edit.price"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                        :state="getValidationState(validationContext)"
                                                        aria-describedby="input-price-live-feedback"
                                                    >
                                                    </b-form-input>

                                                    <b-form-invalid-feedback id="input-price-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col>
                                            <validation-provider
                                                name="Sales Price"
                                                rules="decimal"
                                                v-slot="validationContext"
                                            >
                                                <b-form-group
                                                    id="input-group-cost"
                                                    label="Cost:"
                                                    label-for="input-cost"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-cost"
                                                        v-model="edit.cost"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                        :state="getValidationState(validationContext)"
                                                        aria-describedby="input-cost-live-feedback"
                                                    >
                                                    </b-form-input>

                                                    <b-form-invalid-feedback id="input-cost-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col>
                                            <validation-provider
                                                name="QTY (A)"
                                                rules="integer"
                                                v-slot="validationContext"
                                            >
                                                <b-form-group
                                                    id="input-group-qty-a"
                                                    label="QTY (A):"
                                                    label-for="input-qty-a"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-qty-a"
                                                        v-model="edit.qty_wh_a"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                        :state="getValidationState(validationContext)"
                                                        aria-describedby="input-qty-a-live-feedback"
                                                        disabled
                                                    >
                                                    </b-form-input>

                                                    <b-form-invalid-feedback id="input-qty-a-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col>
                                            <b-form-group
                                                id="input-group-qty-a-bin-loc"
                                                label="BIN LOC:"
                                                label-for="input-qty-a-bin-loc"
                                                label-size="sm"
                                            >
                                                <b-form-input
                                                    id="input-qty-a-bin-loc"
                                                    v-model="edit.bin_a"
                                                    type="text"
                                                    placeholder=""
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>

                                        <b-col>
                                            <validation-provider
                                                name="QTY (B)"
                                                rules="integer"
                                                v-slot="validationContext"
                                            >
                                                <b-form-group
                                                    id="input-group-qty-b"
                                                    label="QTY (B):"
                                                    label-for="input-qty-b"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-qty-b"
                                                        v-model="edit.qty_wh_b"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                        :state="getValidationState(validationContext)"
                                                        aria-describedby="input-qty-b-live-feedback"
                                                        disabled
                                                    >
                                                    </b-form-input>

                                                    <b-form-invalid-feedback id="input-qty-b-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col>
                                            <b-form-group
                                                id="input-group-qty-b-bin-loc"
                                                label="BIN LOC:"
                                                label-for="input-qty-b-bin-loc"
                                                label-size="sm"
                                            >
                                                <b-form-input
                                                    id="input-qty-b-bin-loc"
                                                    v-model="edit.bin_b"
                                                    type="text"
                                                    placeholder=""
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-form-row>

                                    <b-form-group
                                        id="input-group-name"
                                        label="Name:"
                                        label-for="input-name"
                                        label-size="sm"
                                    >
                                        <b-form-input
                                            id="input-name"
                                            v-model="edit.name"
                                            type="text"
                                            placeholder=""
                                            size="sm"
                                            autocomplete="off"
                                           >
                                        </b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        id="input-group-name-parent"
                                        label="Name (Parent):"
                                        label-for="input-name-parent"
                                        label-size="sm"
                                    >
                                        <b-form-input
                                            id="input-name-parent"
                                            v-model="edit.name_parent"
                                            type="text"
                                            placeholder=""
                                            size="sm"
                                            autocomplete="off"
                                            >
                                        </b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        id="textarea-group-description"
                                        label="Short Description:"
                                        label-for="input-image"
                                        label-size="sm"
                                    >
                                        <b-form-textarea
                                            id="textarea-description"
                                            v-model="edit.description"
                                            placeholder=""
                                            rows="3"
                                            max-rows="6"
                                            size="sm"
                                        ></b-form-textarea>
                                    </b-form-group>

                                    <b-form-group
                                        id="textarea-group-description-long"
                                        label="Long Description:"
                                        label-for="input-image"
                                        label-size="sm"
                                    >
                                        <b-form-textarea
                                            id="textarea-description-long"
                                            v-model="edit.description_long"
                                            placeholder=""
                                            rows="3"
                                            max-rows="6"
                                            size="sm"
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col>
                                    <!-- <b-form-group
                                        id="input-group-image"
                                        label="Image:"
                                        label-for="input-image"
                                        label-size="sm"
                                    >
                                        <b-form-row v-if="!imageExists">
                                            <b-col cols="10">
                                                <b-form-file
                                                    v-if="!imageExists"
                                                    id="input-image"
                                                    v-model="file"
                                                    :state="Boolean(file)"
                                                    @input="imageUploadHandler"
                                                    placeholder="Drop file here"
                                                    drop-placeholder="Drop file here..."
                                                    size="sm"

                                                ></b-form-file>
                                            </b-col>
                                            <b-col cols="2">
                                                <b-button v-if="rowData.image_small != undefined" variant="danger" size="sm" @click="toggleImage">X</b-button>
                                            </b-col>
                                        </b-form-row>

                                        <b-form-row v-else>
                                            <b-col cols="4">
                                                <b-img class="thumbnail" :src="generateImgUrl(rowData.sku, rowData.image_small)"></b-img>
                                            </b-col>
                                            <b-col>
                                                <b-button variant="danger" size="sm" @click="toggleImage">Replace Image</b-button>
                                            </b-col>
                                        </b-form-row>
                                    </b-form-group> -->

                                    <b-form-group
                                        id="button-group-image"
                                        label="Image:"
                                        label-for="button-image"
                                        label-size="sm"
                                    >
                                        <b-button class="button-images btn-sm" @click="showImages = 1">Edit Images</b-button>
                                    </b-form-group>
                                </b-col>

                                <b-col>
                                    <validation-provider
                                        name="Video"
                                        rules="url"
                                        v-slot="validationContext"
                                    >
                                        <b-form-group
                                            id="input-group-video"
                                            label="Video:"
                                            label-for="input-video"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-video"
                                                v-model="edit.video"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                                :state="getValidationState(validationContext)"
                                                aria-describedby="input-cost-live-feedback"
                                            >
                                            </b-form-input>

                                            <b-form-invalid-feedback id="input-video-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>

                                <b-col>
                                    <b-form-group
                                        id="button-group-attributes"
                                        label="Attributes:"
                                        label-for="button-attributes"
                                        label-size="sm"
                                    >
                                        <b-button :key="attributeCounterKey" :variant="hasAttributes(0)" class="button-attributes btn-sm" @click="showAttributes = 1">Select Attributes ({{ hasAttributes(1) }})</b-button>
                                    </b-form-group>
                                </b-col>

								<b-col v-if="edit.product_type == 'Bundle'">
									<b-form-group
										id="button-group-components"
										label="Components:"
										label-for="button-components"
										label-size="sm"
									>
										<b-button :key="componentCounterKey" :variant="hasComponents(0)" class="button-components btn-sm" @click="showComponents = 1">Select Components ({{ hasComponents(1) }})</b-button>
									</b-form-group>
								</b-col>
                            </b-form-row>

                            <b-form-group
                                id="input-group-tags"
                                label="Tags:"
                                label-for="input-tags"
                                label-size="sm"
                            >
                                <vue-tags-input
                                    v-model="tag.currentTag"
                                    :tags="edit.tags"
                                    :autocomplete-items="filteredTags"
                                    @tags-changed="newTags => edit.tags = newTags"
                                    placeholder=""
                                />
                            </b-form-group>

                            <b-form-row>
                                <b-col cols="6">
                                    <b-button type="submit" variant="primary" class="btn-sm">
                                        <span v-if="submitting">
                                            <b-spinner small type="grow"></b-spinner>
                                            Updating...
                                        </span>
                                        <span v-else>Save Changes</span>
                                    </b-button>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-row>
                                        <b-col cols="6">
                                            <b-form-group>
                                                <b-form-checkbox
                                                    id="checkbox-active"
                                                    v-model="edit.active"
                                                    name="checkbox-active"
                                                    value="1"
                                                    unchecked-value="0"
                                                    size="lg"
                                                >
                                                Active
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6">
                                            <b-form-group>
                                                <b-form-checkbox
                                                    id="checkbox-archived"
                                                    v-model="edit.archived"
                                                    name="checkbox-archived"
                                                    value="1"
                                                    unchecked-value="0"
                                                    size="lg"
                                                >
                                                    Archived
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                    </b-form-row>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </validation-observer>
                </div>
                <div v-show="showImages">
                    <b-form-row class="image-edit-row" v-for="(img, index) in edit.image" :key="index">
                        <b-col class="image-index" cols="1"><h4>{{ index + 1 }}</h4></b-col>
                        <b-col cols="2">
                            <b-img v-if="(edit.image[index].active && rowData.item_image[index] !== undefined)" class="thumbnail" :src="getImageUrl(rowData.sku, 'SMALL', edit.image[index].sequence, rowData.item_image[index].extension) + '?rnd=' + cacheKey"></b-img>
                            <b-img v-else-if="edit.image[index].string" class="thumbnail" :src="edit.image[index].string"></b-img>
                        </b-col>
                        <b-col class="position-move" cols="2">
                            <span v-if="index != 0 && edit.image[index].active"><b-link @click="imageMove(index, '-1')"><i class="fas fa-long-arrow-alt-up fa-2x"></i></b-link></span><span v-if="index != 9 && edit.image[index].active"><b-link @click="imageMove(index, '1')"><i class="fas fa-long-arrow-alt-down fa-2x"></i></b-link></span>
                        </b-col>
                        <b-col class="file-select">
                            <b-form-file
                                :id="'input-image-' + index"
                                v-model="file[index].state"
                                :state="Boolean(file[index].state)"
                                @input="imageUploadHandler(index)"
                                placeholder="Drop file here"
                                drop-placeholder="Drop file here..."
                                :key="index"
                                :disabled="edit.image[index].active"
                            ></b-form-file>
                        </b-col>
                        <b-col cols="1" class="remove-button">
                            <b-button v-if="edit.image[index].active" variant="danger" size="sm" @click="edit.image[index].active = false">X</b-button>
                        </b-col>
                    </b-form-row>
                </div>
                <div v-show="showAttributes">
                    <b-form-group
                        id="input-group-select-attributes"
                        label="Attributes:"
                        label-for="input-select-acctributes"
                        label-size="sm"
                    >
                        <treeselect
                            name="treeSelect"
                            class="treeSelect"
                            clearable
                            searchable
                            multiple
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder=""
                            @deselect="clearAttribute"
                            :options="attributesFilters"
                            v-model="attributesOption.attributesSelected"
                            />
                    </b-form-group>
                    <b-container fluid>
                        <b-row cols="2">
                            <b-col v-for="(attribute, index) in attributesOption.attributesSelected" :key="index" class="attributes-assign">
                                <b-row>
                                    <b-col class="input-attribute-name" cols="4">
                                        {{ findAttributeName(attribute) }}:
                                    </b-col>
                                    <b-col class="input-attribute-options" cols="8">
                                        <div class="options-assign">
                                            <div class="autosuggest-container">
                                                <vue-autosuggest
                                                    :key="key"
                                                    v-model="edit.attributes[findAttributeName(attribute)]"
                                                    :suggestions="filteredAttributeOptions(findAttributeName(attribute))"
                                                    @focus="focusMe(attribute)"
                                                    @click="clickHandler"
                                                    @input="onInputChange"
                                                    @selected="onSelected"
                                                    :get-suggestion-value="getSuggestionValue"
                                                    :input-props="{id:'autosuggest__input_' + index, placeholder:''}"
                                                    @keyup.enter="suggestFirst(findAttributeName(attribute), $event.target.value)"
                                                    @item-changed="onItemChanged"
                                            >
                                                <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                                                  <!-- <img :style="{ display: 'flex', width: '25px', height: '25px', borderRadius: '15px', marginRight: '10px'}" :src="suggestion.item .avatar" /> -->
                                                  <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.name}}</div>
                                                </div>
                                              </vue-autosuggest>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
				<div v-show="showComponents">
					<b-table-simple hover small responsive bordered sticky-header="430px">
						<b-thead>
							<b-tr>
								<b-th class="text-center th-number">#</b-th>
								<b-th></b-th>
								<b-th>SKU</b-th>
								<b-th class="text-center">QTY</b-th>
								<b-th>Title</b-th>
								<b-th></b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr v-for="(item, index) in edit.components" :key="index" :class="`index-${index}`">
								<td class="text-center">
									{{ index + 1 }}
								</td>
								<td class="text-center">
									<b-img-lazy v-if="item.url" class="products-thumbs" :src="item.url"></b-img-lazy>
								</td>
								<td>
									<autosuggest-instance
										:key="index"
										:idx="index"
										@nextRow="nextRow"
										@suggestFirstRow="suggestFirstRow"
										@onSelectedRow="onSelectedRow"
										@focusMeRow="focusMeRow(index)"
										:ref="'skuinput' + index"
									/>
								</td>
								<td>
									<b-form-input v-model="edit.components[index].qty" size="sm" class="text-center" :ref="'qtyinput' + index" @keyup.13="nextRow(index, 'qty')" @focus="focusMeRow(index)"></b-form-input>
								</td>
								<td>
									<b-form-input v-model="edit.components[index].description" size="sm" class="text-center" :ref="'titleinput' + index" @keyup.13="nextRow(index, 'title')" @focus="focusMeRow(index)" disabled></b-form-input>
								</td>
								 <td class="text-center"><b-button size="sm" variant="danger" @click="deleteRow(index)"><i class="far fa-trash-alt"></i></b-button></td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
                    <b-row>
                        <b-col cols="2">
                            <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
                        </b-col>
                    </b-row>
				</div>
            </div>
        </b-modal>
	</div>
</template>

<script>
    const arrayMove = require('array-move')
	import Treeselect from '@riophae/vue-treeselect'
    import VueTagsInput from '@johmun/vue-tags-input'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { VueAutosuggest } from 'vue-autosuggest'
	import AutosuggestInstance from '../../../../../pages/user/inventory/products/AutosuggestInstance'
	export default {
		props: [
            'row',
			'categories',
			'vendors',
            'attributes',
			'attributesFilters',
            'attributesOptions',
            'tags'
		],

		components: {
			Treeselect,
            VueTagsInput,
            VueAutosuggest,
			AutosuggestInstance,
		},

		data() {
			return {
				modalName: 'modal-inventory-products-edit-product',
                rowData: null,
				edit: {
                    // active: 1,
                    attributes: {},
                    tags: [],
                    image: [],
					product_type: '',
                    components: []
                },
				file: [],
                key: 1,
                attributeCounterKey: 1,
				componentCounterKey: 1,
                submitting: 0,
                showAttributes: 0,
				showComponents: 0,
                showImages: 0,
                attributesOption: {
                    attributesSelected: [],
                    currentAttribute: '',
                    currentOptions: [
                        {
                            data: []
                        }
                    ],
                    selectedOptions: [],
                    selected: '',
                    key: 1
                },
                tag: {
                    currentTag: ''
                },
                imageInput: {},
                dataReady: 0,
                cacheKey: 0,
                imgRowKey: 0
			}
		},

		methods: {
            imageMove(index, direction) {
                arrayMove.mutate(this.rowData.item_image, index, (+index + +direction))
                arrayMove.mutate(this.file, index, (+index + +direction))
                arrayMove.mutate(this.edit.image, index, (+index + +direction))
                // this.cacheKey++
            },

			clearAttribute(attr) {
                this.edit.attributes[attr.label] = ''
                this.attributeCounterKey++
            },

            hasAttributes(counted) {
                let obj = this.edit.attributes
                var counter = 0

                Object.values(obj).forEach(value => {
                    if (value.length) {
                        counter++
                    }
                })

                if (counted) {
                    return counter
                } else {
                    if (counter) {
                        return 'success'
                    } else {
                        return 'outline-secondary'
                    }
                }
            },

			clearComponent(comp) {
                // this.edit.components[attr.label] = ''
                this.componentCounterKey++
            },

            hasComponents(counted) {
                let obj = this.edit.components
                var counter = 0

                Object.values(obj).forEach(value => {
                    if (value.sku.length) {
                        counter++
                    }
                })

                if (counted) {
                    return counter
                } else {
                    if (counter) {
                        return 'success'
                    } else {
                        return 'outline-secondary'
                    }
                }
            },

            findAttributeName(id) {
                let index = this.findIndex(this.attributesFilters, 'id', id)
                return this.attributesFilters[index].label
            },

            filteredAttributeOptions(index) {
                return [
                    {
                        data: this.attributesOption.currentOptions[0].data.filter(option => {
                            return option.name.toLowerCase().indexOf(this.edit.attributes[index].toLowerCase()) > -1;
                        })
                    }
                ]
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },

            suggestFirst(attribute, query) {
                let arr = this.attributesOption.currentOptions[0].data

                for (var i = 0; i < arr.length; i++) {
                    let cur = arr[i].name.toLowerCase()
                    if (cur.includes(query.toLowerCase())) {
                        this.edit.attributes[attribute] = arr[i].name
                        this.key++
                        this.attributeCounterKey++

                        break;
                    } else {
                        continue
                    }
                }
            },

            getSuggestionValue(attribute) {
                return attribute.item.name;
            },

            focusMe(e) {
                this.$nextTick(() => {
                    this.attributesOption.currentOptions[0].data != [] ? this.attributesOption.currentOptions[0].data = this.attributesOptions[e] : ''
                    this.attributesOption.currentAttribute = this.findAttributeName(e)
                })
            },

            clickHandler(item) {
              // event fired when clicking on the input
            },

            onInputChange(text) {
                this.attributesOption.key++
                this.attributeCounterKey++
            },

            onSelected(item) {
                if (item) {
                    this.edit.attributes[this.attributesOption.currentAttribute] = item.item.name
                    this.attributeCounterKey++
                }
            },

            onItemChanged(text) {
                if (text) {
                    this.edit.attributes[this.attributesOption.currentAttribute] = text.item.name
                    this.attributeCounterKey++
                }
            },

            imageUploadHandler(index) {
                const file = this.file[index].state
                if (file) {
                    const reader = new FileReader()
                    reader.onload = e => this.edit.image[index].string = reader.result
                    reader.readAsDataURL(file);
                    this.edit.image[index].filename = file.name
                }
            },

            editProduct() {
                this.submitting = 1
                let editData = this.edit

                let url = 'api/inventory/products/edit'
                axios.post(url, {
                    editData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Product Edited', 'SKU: ' + editData.sku + ' edited successfully!')
                        // this.editData
                        this.$emit('updateRow')
                    } else {
                        this.showAlertBox('error', 'Error Creating Product', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getRow(id) {
                var self = this
                this.attributes.forEach(function (attribute, index) {
                    let name = attribute.name
                    self.edit.attributes[name] = ''
                })

                let url = 'api/inventory/products/getproduct/' + id
                axios.get(url, {})
                .then((res) => {
                    this.rowData = res.data.items
                    this.cacheKey = this.$moment().unix()

                    for (var i = 0; i < 10; i++) {
                        let active = res.data.items.item_image[i] != undefined ? true : false
                        let id = active ? res.data.items.item_image[i].id : null
                        let sequence = active ? res.data.items.item_image[i].sequence : null
                        this.edit.image.push({id: id, string: null, filename: null, sequence: sequence, position: i + 1, active: active})
                        this.file.push({state: null})
                    }

                    for (const [key, value] of Object.entries(res.data.items)) {
                        if (key != 'item_attribute' && key != 'tags' && key != 'components') {
                            this.edit[key] = value
                        }

                        if (key == 'item_attribute') {
                            value.forEach(function (attribute) {
                                self.attributesOption.attributesSelected.push(attribute.attributes_id)
                                self.edit.attributes[self.findAttributeName(attribute.attributes_id)] = attribute.item_attribute_option.attribute_option.value
                            })
                        }

                        if (key == 'components') {
                            if (key.length) {
                                this.edit.components = []
                                value.forEach(function (component) {
                                    self.edit.components.push({sku: component.line_item.sku, qty: component.quantity, description: component.line_item.description})
                                })
                            } else {
                                for (var index = 0; index <= 2; index++) {
                                    this.edit.components.push({sku: '', qty: '', description: ''})
                                }

                                this.currentIndex = ''
                            }
                        }

                        if (key == 'tags') {
                            value.forEach(function (tag) {
                                self.edit.tags.push({text: tag.tag.name})
                            })
                        }
                    }

                    this.dataReady = 1
                    this.attributesOption.key++
                }, () => {
                    this.has_error = true
                })
            },

			resetView() {
                this.edit.components = []

                for (var index = 0; index <= 2; index++) {
                    this.edit.components.push({sku: '', qty: '', description: ''})
                }

                this.currentIndex = ''
            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.edit.components.push({sku: '', qty: '', description: ''})
                }
            },

            nextRow(idx, col) {
                let target = col + 'input' + (idx + 1)

                if (col == 'sku') {
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
                } else {
                    this.$refs[target][0].$el.focus()

                }
            },

            suggestFirstRow(idx, sku, description, rate, url, qoh, cost, available, mpn, lastCost, qoo, vendor) {
                this.edit.components[idx].sku = sku
                this.edit.components[idx].description = description
                this.edit.components[idx].url = url
            },

            onSelectedRow(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed, available, mpn, lastCost, qoo, vendor) {
                this.edit.components[idx].sku = sku
                this.edit.components[idx].description = description
                this.edit.components[idx].url = url
            },

            focusMeRow(index) {
                if (this.edit.components.length == index + 1) {
                    this.edit.components.push({sku: '', qty: '', description: '', url: ''})

                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }
            },

            deleteRow(index) {
                let previousSkus = []
                this.edit.components.forEach((row, idx, array) => {
                    if (row.sku && idx != index) {
                        previousSkus.push(row.sku)
                    }
                })

                let target = 'skuinput' + (index + 1)
                if (this.edit.components.length == 1 && index == 0) {
                    this.edit.components[0].sku = ''
                    this.edit.components[0].description = ''
                    this.edit.components[0].qty = ''
                    this.edit.components[0].url = ''
                } else {
                    this.edit.components.splice(index, 1)
                }

                this.edit.components.forEach((row, idx, array) => {
                    if (row.sku) {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = previousSkus[idx]
                        this.$refs['skuinput' + idx][0].query = row.sku
                    } else {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = ''
                        this.$refs['skuinput' + idx][0].query = ''
                    }
                })
            },

            populateComponentSkus() {
                var self = this
                this.$nextTick(() => {
                    self.edit.components.forEach((row, idx, array) => {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = row.sku
                        this.$refs['skuinput' + idx][0].query = row.sku
                    })
                })
            }
		},

		computed: {
			filteredTags() {
                return this.tags.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.currentTag.toLowerCase()) !== -1;
                })
            }
		},

		mounted() {
            this.getRow(this.row)
		},

        updated() {
            this.populateComponentSkus()
        }
	}
</script>
<style lang="scss">
    #modal-inventory-products-edit-product {
        .modal-title {
            width: 100%;
        }

        .modal-content {
            min-height: 600px;
        }

        .vue-treeselect__control {
            height: calc(1.5em + 0.3rem + 2px);
        }

        .vue-tags-input {
            max-width: 100%;

            .ti-input {
                display: block;
                width: auto;
                height: calc(1.5em + 0.75rem + 2px);
                // padding: 0.375rem 0.75rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #495057;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
        }

        .button-images, .button-attributes, .button-components {
            width: 100%;
        }

        .input-attribute-name {
            padding-top: 3px;
            text-align: right;
        }

        .input-attribute-options {
            // padding: 5px;
        }

        .attributes-assign {
            padding-bottom: 15px;
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                justify-content: center;
                width: 100%;
            }

            #autosuggest { width: 100%; display: block; }
            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }
        }

        .thumbnail {
            width: 55px;
            height: 55px;
            border: 1px #ccc solid;
            padding: 5px;
        }

        .image-edit-row {
            border-bottom: 1px #ccc solid;
            padding: 10px;

            .position-move, .image-index, .file-select, .remove-button {
                padding-top: 8px;
            }

            .remove-button {
                text-align: right;
            }
        }
    }
</style>
